export enum EventosActionTypeEnum {
    IS_ONLINE = 'IS_ONLINE'
}